import { gql } from '@apollo/client'

/**
 * Vive numa query SEPARADA da getEnrollment de propósito. `blockedCourseContents` é um
 * campo novo do core, e campo que o servidor não conhece é erro de VALIDAÇÃO: derruba a
 * resposta inteira, não só ele. Dentro da getEnrollment, uma janela de deploy com o
 * members novo e o core antigo deixava a tela do curso sem nenhum módulo, só com o toast
 * de erro — reproduzido em staging em 24/09/2026.
 *
 * `requiredLessonId` é a aula que destrava cada conteúdo. Vem junto porque o servidor lê
 * as conclusões do seshat, que ingere por fila: logo depois de concluir a aula o gate
 * ainda responde o estado anterior (~1,4s medido em staging). Com esse id o cliente
 * destrava na hora, cruzando com o progresso que ele mesmo acabou de registrar.
 */
export const GET_LINEAR_PROGRESS_GATE = gql`
  query getLinearProgressGate($id: ID!, $courseId: ID!) {
    enrollment(id: $id) {
      id
      blockedCourseContents(courseId: $courseId) {
        courseContentId
        requiredLessonId
      }
    }
  }
`
